import { useQuery } from '@tanstack/react-query';
import { Package, CheckCircle, AlertTriangle, Clock } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { supabase } from '@/integrations/supabase/client';

export const EquipmentWidget = () => {
  const { data: equipmentData, isLoading } = useQuery({
    queryKey: ['equipment-widget'],
    queryFn: async () => {
      // TODO: Equipment tables not yet created - temporarily disabled
      return {
        totalEquipment: 0,
        assignedEquipment: 0,
        returnedEquipment: 0,
        overdueEquipment: 0,
        equipmentTypes: 0,
        totalValue: 0
      };
    },
    refetchInterval: 60000,
  });

  if (isLoading) {
    return (
      <Card className="p-6 animate-pulse">
        <div className="h-32 bg-muted rounded"></div>
      </Card>
    );
  }

  return (
    <Card className="p-6">
      <div className="flex items-center gap-3 mb-4">
        <Package className="w-6 h-6 text-orange-500" />
        <h3 className="text-lg font-semibold">Equipment</h3>
      </div>
      
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-orange-600">{equipmentData?.assignedEquipment || 0}</div>
          <div className="text-sm text-muted-foreground">Currently Assigned</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-blue-600">{equipmentData?.equipmentTypes || 0}</div>
          <div className="text-sm text-muted-foreground">Equipment Types</div>
        </div>
      </div>

      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4 text-green-500" />
            <span className="text-sm">Returned</span>
          </div>
          <Badge variant="default">{equipmentData?.returnedEquipment || 0}</Badge>
        </div>
        
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <AlertTriangle className="w-4 h-4 text-red-500" />
            <span className="text-sm">Overdue (30+ days)</span>
          </div>
          <Badge variant={equipmentData?.overdueEquipment ? "destructive" : "secondary"}>
            {equipmentData?.overdueEquipment || 0}
          </Badge>
        </div>

        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <Package className="w-4 h-4 text-blue-500" />
            <span className="text-sm">Total Value</span>
          </div>
          <Badge variant="outline">
            €{equipmentData?.totalValue?.toFixed(2) || '0.00'}
          </Badge>
        </div>
      </div>
    </Card>
  );
};